import './ServicesPage.css';
import { Helmet } from 'react-helmet';
import Header from '../../components/header/Header';
import ServicesCard from '../../components/ServicesCard/ServicesCard';
import ashi_logo from '../../images/homepage/ashi.png';
import clia_logo from '../../images/homepage/clia.png';

const ServicesPage = ({ headers, services, theme }) => {
  return (
    <div>
      <Helmet>
        <title>
          Scisco Genetics Typing Services - HLA Typing, KIR Typing, FcGR typing and Chimerism Testing
        </title>
        <meta
          name='description'
          content='Typing Services for HLA, KIR, FcR, Chimerism testing and targeted sequencing upon special request - HLA typing, KIR typing, FcGR typing, Chimerism testing'
        />
      </Helmet>
      <Header header={headers.filter((header) => header.key === 'services')} />

      {/* ── HERO ── */}
      <section className='services-hero'>
        <h1 className='services-hero-title'>
          Next Generation Sequencing for<br />
          <span className='services-hero-accent'>Complex Gene Systems</span>
        </h1>
        <div className='services-hero-copy'>
          <p className='services-hero-desc'>
            Send DNA, receive high-resolution genotypes. Our typing services run on
            the same ScisGo&trade; NGS technology in active use in clinical
            laboratories&mdash;no assay development required on your side.
          </p>
          <p className='services-hero-desc'>
            From HLA and KIR to MICAB, Fc receptor profiling, chimerism testing and
            targeted variation detection, every service returns phased, reportable
            results with standard or customized reporting options.
          </p>
        </div>
        {/* Accreditation marks, same pair as the footer and the home page
            .cert section. Stacked to the right of the paragraphs and centred
            against them, ASHI on top. */}
        <div className='services-hero-cert'>
          <img src={ashi_logo} className='services-hero-logo' alt='ASHI logo' />
          <img src={clia_logo} className='services-hero-logo' alt='CLIA logo' />
        </div>
      </section>

      {/* ── SERVICES ── */}
      <ServicesCard services={services} theme={theme} />
    </div>
  );
};

export default ServicesPage;
